export enum FieldType {
    String,
    Number,
    Boolean,
    Link,
    Date,
    Report,
    User,
    Avatar
}